export const randomIntFromInterval = (min, max, divider = 1) => Math.floor(Math.random() * (max - min + 1) + min) / divider
